import * as React from "react";

const IconFMI = ({ width, height }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      enableBackground: "new 0 0 116 152",
    }}
    viewBox="0 0 116 152"
    width={width}
    height={height}
  >
    <path
      d="M112.5 1H3.5c-1.1 0-2 .9-2 2v146c0 1.1.9 2 2 2h109c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zM85.7 140h-5.5V68.7H69.7V140h-5.5V68.7H53.6V140h-5.5V63.2H63l3.9 3.9 3.9-3.9h14.9V140zm0-108.7H39.8V49.4h45.9v5.5H39.8V140h-5.5V25.8h51.4v5.5zM99.5 140H94V25.8h5.5V140zm7.9-122.5H26V140h-5.5V17.5H8.7V12h98.8l-.1 5.5z"
      style={{
        fill: "#1b1921",
      }}
    />
  </svg>
);
export default IconFMI;
